export default __webpack_public_path__ + "static/media/image2.087a72e9.svg";